import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import payFlow from '@/views/payFlow/index'
import orderDetail from '@/views/orderDetail/index'
import orders from '@/views/orders/index'
import payFee from '@/views/payFee/index'
import cardManage from '@/views/cardManage/index'
import payResult from '@/views/payResult/index'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'orders',
            component: orders
        },
        {
            path: '/orderDetail',
            name: 'orderDetail',
            component: orderDetail,
            meta: {
                title: '订单确认',
            }
        },
        {
            path: '/payFlow',
            name: 'payFlow',
            component: payFlow,
            meta: {
                title: '添加就诊人',
            }
        },
        {
            path: '/orders',
            name: 'orders',
            component: orders
        },
        {
            path: '/payFee',
            name: 'payFee',
            component: payFee,
            meta: {
                title: '订单支付',
            }
        },
        {
            path: '/cardManage',
            name: 'cardManage',
            component: cardManage,
            meta: {
                title: '就诊卡管理',
            }
        },
        {
            path: '/payResult',
            name: 'payResult',
            component: payResult,
            meta: {
                title: '缴费详情',
            }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js